import Toast from "react-native-toast-message";
import { ToastContent } from "./ToastContent";
export const ThemedToast = ({ fluid, maxWidth, compact, } = {}) => {
    const widthProps = fluid
        ? { fluid, maxWidth, compact }
        : {};
    return (<Toast config={{
            success: (props) => (<ToastContent {...props} text1={props.text1 ?? ""} text2={props.text2 ?? ""} onClose={props.props?.dismissible ? () => props.hide() : undefined} closeButtonLabel={props.props?.closeButtonLabel} {...widthProps}/>),
            error: (props) => (<ToastContent {...props} text1={props.text1 ?? ""} text2={props.text2 ?? ""} onClose={props.props?.dismissible ? () => props.hide() : undefined} closeButtonLabel={props.props?.closeButtonLabel} {...widthProps}/>),
            info: (props) => (<ToastContent {...props} text1={props.text1 ?? ""} text2={props.text2 ?? ""} onClose={props.props?.dismissible ? () => props.hide() : undefined} closeButtonLabel={props.props?.closeButtonLabel} {...widthProps}/>),
        }}/>);
};
ThemedToast.show = Toast.show;
ThemedToast.hide = Toast.hide;
//# sourceMappingURL=ThemedToast.js.map